import React from 'react';
import Slider from '@mui/material/Slider';

function ChaletSearchResultSlider({ title, min, max, step, defaultValue, onChange, marks, numberType }) {

    const [value, setValue] = React.useState(defaultValue);

    const handleChange = (event: Event, newValue: number | number[]) => {
        setValue(newValue);
        onChange(newValue);
    };

    React.useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    // Function to format numbers with commas
    const formatNumberWithCommas = (number) => {
        return number.toLocaleString();
    };

    // Function to format the mark labels based on numberType
    const formatLabel = (markValue) => {
        const formattedValue = formatNumberWithCommas(markValue);
        switch (numberType) {
            case 'distance':
                return `${formattedValue}m`;
            case 'money':
                return `\u00A3${formattedValue}`; // Use Unicode for �
            default:
                return formattedValue; // For any other types or unformatted
        }
    };

    // Map over the marks and format their labels based on numberType
    const formattedMarks = marks.map(mark => ({
        ...mark,
        label: formatLabel(mark.value)
    }));

    return (
        <div style={{ margin: '20px 0' }}>
            <div className="refiner-heading">{title}</div>

            <Slider
                value={value}
                onChange={handleChange}
                valueLabelDisplay="auto"
                step={step}
                min={min}
                max={max}
                marks={formattedMarks} // Use formatted marks here
            />
        </div>
    );
}

export default ChaletSearchResultSlider;
